<template>
	<div class='list-wrap'>
		<div class="nav-wrap">
			<div class="flex">
				<i class="iconfont icon-home1"></i>
				<router-link class="link" to="/antiDisease">疫情专题</router-link>
				<i class="el-icon-arrow-right"></i>
				<router-link to="/antiDisease" class="link">疫情防控红黑榜</router-link>
				<i class="el-icon-arrow-right"></i>
				<router-link class="link" :to="`/antiDiseaseList?type=${typeName}&id=${category}`" replace><span>{{typeName}}</span></router-link>
			</div>
		</div>
		<div class="list-bottom">
			<empty v-if="!list.length" />
			<ul class="commitment-table" v-else>
				<li class="flex" v-for="item in list" :key="item.id">
					<router-link class="flex antidisease--list" :to="`/common/article/0/${item.id}`" tag="a" target="_blank">
						<span class="title ellipsis-1">{{item.title}}</span>
						<span class="source ellipsis-1">{{item.source}}</span>
						<span class="time">{{item.publishtime}}</span>
					</router-link>
				</li>
			</ul>
			<div class="flex flex-row-end page-wrap" v-if="list.length>0">
				<el-pagination background layout="total, prev, pager, next" :pageSize="pageSize" :total="total" @current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import empty from '@/components/empty';
import { articleTopics } from '@/api';

export default {
	components: {
		empty
	},
	data() {
		return {
			typeName: undefined,
			category: undefined,
			list: [],
			pageSize: 15,
			total: 0
		}
	},
	created() {
		const { query: { type, id: category } } = this.$route;
		this.$set(this, 'typeName', type);
		this.$set(this, 'category', category);
	},
	mounted() {
		this.getList();
	},
	methods: {

		handleCurrentChange(e) {
			this.getList(e);
		},
		getList(page = 1) {
			const { query: { category } } = this.$route;
      console.log("============category===============")
      console.log(category)
			articleTopics({ category, current: page }).then(res => {
				this.setResponse(res);
			})
		},
		setResponse(response) {
			const { records, total, size, } = response;

			this.$set(this, 'list', records || []);
			this.$set(this, 'total', total);
			this.$set(this, 'pageSize', size);
		},
	},
	computed: {},
	watch: {},
}
</script>
<style lang='scss'>
	.list-wrap {
		.list-bottom {
			width: 1280px;
			margin: 0 auto;
			border-top: 3px solid #d01c0b;
			padding: 0 10px 20px;

			.commitment-table {
				width: 100%;

				& > .commitment-header {
					background-color: #f4f4f4;
				}
				& > li {
					height: 46px;
					text-align: center;
					border-bottom: 1px dashed hsla(0, 0%, 44%, 0.8);
					& > p {
						width: 100px;
						flex-shrink: 0;
						&:first-of-type {
							width: 80px;
						}
						&:nth-child(2) {
							flex-grow: 2;
						}
						&:nth-child(3) {
							width: 150px;
						}
					}
					&:nth-child(even) {
						background-color: #fbfbfb;
					}
				}
			}
			.page-wrap {
				margin: 20px auto;
				width: 1120px;
			}

			.flex {
				width: 100%;
				& > .title {
					flex-grow: 2;
					color: #333;
					font-size: 16px;
					padding-right: 15px;
					text-align: left;
					padding-right: 10%;
				}
				& > .source {
					color: #999;
					font-size: 14px;
					font-weight: 400;
					flex-basis: 15%;
					text-align: right;
					flex-shrink: 0;
				}
				& > .time {
					color: #999;
					font-size: 14px;
					font-weight: 400;
					flex-shrink: 0;
					padding-left: 10px;
					border-left: 2px solid #999;
					margin-left: 10px;
				}
			}
		}
	}
</style>